export class DailyReport {
  startDate: Date;
  endDate: Date;
  timeSec: number;
  reportType: string;
  NumberOfFirstVisit: number; // 初診人次
  NumberOfFirstVisitPeople: number; // 初診人數
  NumberOfRevisit: number; // 複診人次
  NumberOfRevisitPeople: number; // 複診人數
  NumberOfTotalVisit: number; // 總人次
  NumberOfTotalVisitPeople: number; // 總人數
  ReportTime: Date;
  Items: DailyReportItem[];
  Sum: DailyReportIcodeSum[];
}
export class DailyReportItem {
  Id: string;
  RegDate: Date;
  TimeSecName: string;
  PatientName: string;
  FeeReg: number;
  FeeExam: number;
  FeeInternal: number;
  FeeOthers: number;
  Debt: number;
  Repay: number;
  Received: number;
  IsDailyTotal: boolean;
  IsSummary: boolean;
  PatientNo: string;
  PatientBirth: Date;
  VisitSourceCode: string;
  Icode: string;
  IcodeName: string;
  Isqno: string;
  StatusCode: string;
  StatusWord: string;
  SameTreat: string;
  field1: string;
  RoomCode: string;
  DoctorId: number;
  APartOPD: number;
  APartDrug: number;
  APartExam: number;
  FeeLAMT: number;
  FeeTotal: number;
  DUTYCreater: string;
  DoctorAccount: string;
  DoctorName: string;
  AOwn: number;
  Remark: string;
  HRxs?: string[];
  JaPhone?: string;
  JaAddr?: string;
  Sptx?: string;
  PatientCid?: string;
  Icdt?: string; // 刷卡時間 1100322111640 yyyMMddhhmmss
  // field3: number;
  // field4: number;
  PaidCash: number;
  PaidCreditCard: number;
  PaidCashCard: number;
  PaidMedCard: number;
  PaidTransfer: number;
  PaidEPayment: number;
  PaidOther: number;
  PaidSum: number;
}
export class DailyReportIcodeSum {
  Icode: string;
  FeeReg: number;
  People: number; // 人數
  NumberOfFirstVisitPeople: number; // 初診人數
  NumberOfRevisitPeople: number; // 複診人數
  NumberOfType3People: number; // 複診人數
  NumberOfType3RecardPeople: number; // 複診人數
  APartOPD: number;
  APartDrug: number;
  APartExam: number;
  FeeOwn: number;
  SubSum: number;
  Deposit: number;
  PaidCash: number;
  PaidCreditCard: number;
  PaidCashCard: number;
  PaidMedCard: number;
  PaidTransfer: number;
  PaidEPayment: number;
  PaidOther: number;
  PaidSum: number;
}

export class DailyReportColControl {
  Col: string;
  Name: string;
  Seq: number;
  Witdh: number;
  Height: number;
  // IsHide: number;
}


export class DailyPaymentMaster {
  Id: number;
  SerialNumber: string;
  Payable: number;
  Paid: number;
  TimeSec: number;
  Status: number;
  Detail: PaymentDetailInfo[];
  PatientName: string;
  PatientNo: string;
  constructor() {
    this.Detail = [];
  }
}

export class PaymentDetailInfo {
  FeeCode: string;
  OwnPay?: number;
  SubTotal?: number;
  TypeCode?: string;
  FeeCodeName: string;
  constructor() {
    this.FeeCode = '';
    this.OwnPay = null;
    this.SubTotal = null;
    this.TypeCode = null;
  }
}
export class PAYdetailFeeCode {
  static readonly feeCodeMap: { FeeCode: string, Type: string, Name: string }[] = [
    { FeeCode: 'A0', Type: '', Name: '掛號費' },
    { FeeCode: 'A98', Type: '', Name: '部分負擔' },
    { FeeCode: 'LAMT', Type: '', Name: '押金' },
    { FeeCode: 'A97', Type: '', Name: '藥部分負擔' },
    { FeeCode: 'A67', Type: '', Name: '檢部分負擔' },
    { FeeCode: 'A96', Type: '', Name: '自費' },
    { FeeCode: 'A96Other', Type: '', Name: '自費診其他自費' },
    { FeeCode: 'A96Rx', Type: '', Name: '醫令自費' }

  ];

  // 根據 FeeCode 和 TypeCode 取得名稱
  static getName(feeCode: string, typeCode?: string): string {
    const found = this.feeCodeMap.find(
      entry => entry.FeeCode === feeCode && (entry.Type === typeCode || entry.Type === '')
    );

    return found ? found.Name : '';
  }
  static 体普思自費(): string {
    return [
      '自費機制:１.[掛號台自費]+[醫令自費]+([自費診其他自費])　２.[診間自費]優先權(２大於１)',
      '即當診間修改自費且大於0時，結帳報表會以診間自費為主，若診間自費為0則看規則1的總合',
      '掛號參數[EnableRegisterSyncFinishedSelfPay]的啟用預設為是，同步的話則完診時掛號是以1or2的值呈現，若設不同步則只會顯示[掛號台自費]'
    ].join('\n');
  }
}


// export const DailyReportColEnum: { Seq: number, Col: string, Name: string, Witdh: number, Height: number, IsNeedHide: boolean }[] =
//   [
//     // {Col: 'RegDate', Name: '掛號日' },
//     { Seq: 1, Col: 'PatientName', Name: '姓名', Witdh: 8, Height: 2, IsNeedHide: true },
//     { Seq: 2, Col: 'Icdt', Name: '過卡時間', Witdh: 12, Height: 2, IsNeedHide: false },
//     { Seq: 3, Col: 'IcodeName', Name: '身分', Witdh: 4, Height: 1, IsNeedHide: false },
//     { Seq: 4, Col: 'Isqno', Name: '卡序', Witdh: 4, Height: 1, IsNeedHide: false },
//     //  {Seq:4, Col: 'PatientCid', Name: '身分證號',Witdh:8 ,IsNeedHide:false },
//     //  {Seq:5, Col: 'Sptx', Name: '特治',Witdh:8 ,IsNeedHide:false },
//     { Seq: 5, Col: 'TimeSecName', Name: '時段', Witdh: 2, Height: 1, IsNeedHide: false },
//     { Seq: 6, Col: 'StatusWord', Name: '狀態', Witdh: 2, Height: 1, IsNeedHide: false },
//     { Seq: 7, Col: 'SameTreat', Name: '類', Witdh: 2, Height: 1, IsNeedHide: false },
//     { Seq: 8, Col: 'CusNo', Name: '次', Witdh: 2, Height: 1, IsNeedHide: false },
//     { Seq: 9, Col: 'DispTp', Name: '調劑', Witdh: 2, Height: 1, IsNeedHide: false },
//     { Seq: 10, Col: 'DUTYCreater', Name: '櫃台', Witdh: 7, Height: 2, IsNeedHide: true },
//     { Seq: 11, Col: 'RoomCode', Name: '診', Witdh: 2, Height: 1, IsNeedHide: false },
//     { Seq: 12, Col: 'DoctorName', Name: '醫師', Witdh: 8, Height: 2, IsNeedHide: true },
//     { Seq: 13, Col: 'FeeReg', Name: '掛號費', Witdh: 6, Height: 1, IsNeedHide: false },
//     { Seq: 14, Col: 'APartOPD', Name: '部份負擔', Witdh: 7, Height: 1, IsNeedHide: false },
//     { Seq: 15, Col: 'AOwn', Name: '自費', Witdh: 7, Height: 1, IsNeedHide: false },
//     { Seq: 16, Col: 'APartDrug', Name: '藥部份負擔', Witdh: 7, Height: 1, IsNeedHide: false },
//     { Seq: 17, Col: 'APartExam', Name: '檢部份負擔', Witdh: 7, Height: 1, IsNeedHide: false },
//     { Seq: 18, Col: 'FeeLAMT', Name: '押金', Witdh: 7, Height: 1, IsNeedHide: false },
//     { Seq: 19, Col: 'Debt', Name: '欠款', Witdh: 7, Height: 1, IsNeedHide: false },
//     { Seq: 20, Col: 'Repay', Name: '還款', Witdh: 7, Height: 1, IsNeedHide: false },
//     { Seq: 21, Col: 'Received', Name: '小計', Witdh: 7, Height: 1, IsNeedHide: false },
//     { Seq: 22, Col: 'FeeTotal', Name: '掛帳費', Witdh: 7, Height: 1, IsNeedHide: false },
//     { Seq: 23, Col: 'Remark', Name: '說明', Witdh: 10, Height: 2, IsNeedHide: true }
//   ];

export const DailyReportPayColEnum: { Seq: number, Col: string, Name: string, Witdh: number, Height: number, IsNeedHide: boolean }[] =
  [
    { Seq: 24, Col: 'PaidCash', Name: '現金', Witdh: 7, Height: 1, IsNeedHide: false },
    { Seq: 25, Col: 'PaidCreditCard', Name: '信用卡', Witdh: 7, Height: 1, IsNeedHide: false },
    { Seq: 26, Col: 'PaidCashCard', Name: '現金卡', Witdh: 7, Height: 1, IsNeedHide: false },
    { Seq: 27, Col: 'PaidMedCard', Name: '醫保卡', Witdh: 7, Height: 1, IsNeedHide: false },
    { Seq: 28, Col: 'PaidTransfer', Name: '轉帳', Witdh: 7, Height: 1, IsNeedHide: false },
    { Seq: 29, Col: 'PaidEPayment', Name: '電子支付', Witdh: 7, Height: 1, IsNeedHide: false },
    { Seq: 30, Col: 'PaidOther', Name: '其他', Witdh: 7, Height: 1, IsNeedHide: false },
    { Seq: 31, Col: 'PaidSum', Name: '付款小計', Witdh: 7, Height: 1, IsNeedHide: false },
  ];


export interface DailyReportCol {
  Seq: number;
  Col: string;
  Name: string;
  Witdh: number;
  Height: number;
  IsNeedHide: boolean;
  CanControlHide: boolean;  // 🔹 新增欄位
}

// 原始的常數陣列 (多加 CanControlHide)
export const DailyReportColEnum: DailyReportCol[] = [
  { Seq: 101, Col: 'PatientNo', Name: '病歷號', Witdh: 7, Height: 1, IsNeedHide: false, CanControlHide: false },
  { Seq: 102, Col: 'Date', Name: '日期', Witdh: 7, Height: 1, IsNeedHide: false, CanControlHide: false },
  { Seq: 1, Col: 'PatientName', Name: '姓名', Witdh: 8, Height: 2, IsNeedHide: true, CanControlHide: true },
  { Seq: 2, Col: 'Icdt', Name: '過卡時間', Witdh: 12, Height: 2, IsNeedHide: false, CanControlHide: true },
  { Seq: 3, Col: 'IcodeName', Name: '身分', Witdh: 4, Height: 1, IsNeedHide: false, CanControlHide: true },
  { Seq: 4, Col: 'Isqno', Name: '卡序', Witdh: 4, Height: 1, IsNeedHide: false, CanControlHide: true },
  { Seq: 5, Col: 'TimeSecName', Name: '時段', Witdh: 2, Height: 1, IsNeedHide: false, CanControlHide: true },
  { Seq: 6, Col: 'StatusWord', Name: '狀態', Witdh: 2, Height: 1, IsNeedHide: false, CanControlHide: true },
  { Seq: 7, Col: 'SameTreat', Name: '類', Witdh: 2, Height: 1, IsNeedHide: false, CanControlHide: true },
  { Seq: 8, Col: 'CusNo', Name: '次', Witdh: 2, Height: 1, IsNeedHide: false, CanControlHide: true },
  { Seq: 9, Col: 'DispTp', Name: '調劑', Witdh: 2, Height: 1, IsNeedHide: false, CanControlHide: true },
  { Seq: 10, Col: 'DUTYCreater', Name: '櫃台', Witdh: 7, Height: 2, IsNeedHide: true, CanControlHide: true },
  { Seq: 11, Col: 'RoomCode', Name: '診', Witdh: 2, Height: 1, IsNeedHide: false, CanControlHide: true },
  { Seq: 12, Col: 'DoctorName', Name: '醫師', Witdh: 8, Height: 2, IsNeedHide: true, CanControlHide: true },
  { Seq: 13, Col: 'FeeReg', Name: '掛號費', Witdh: 6, Height: 1, IsNeedHide: false, CanControlHide: true },
  { Seq: 14, Col: 'APartOPD', Name: '部份負擔', Witdh: 7, Height: 1, IsNeedHide: false, CanControlHide: true },
  { Seq: 15, Col: 'AOwn', Name: '自費', Witdh: 7, Height: 1, IsNeedHide: false, CanControlHide: true },
  { Seq: 16, Col: 'APartDrug', Name: '藥部份負擔', Witdh: 7, Height: 1, IsNeedHide: false, CanControlHide: true },
  { Seq: 17, Col: 'APartExam', Name: '檢部份負擔', Witdh: 7, Height: 1, IsNeedHide: false, CanControlHide: true },
  { Seq: 18, Col: 'FeeLAMT', Name: '押金', Witdh: 7, Height: 1, IsNeedHide: false, CanControlHide: true },
  { Seq: 19, Col: 'Debt', Name: '欠款', Witdh: 7, Height: 1, IsNeedHide: false, CanControlHide: true },
  { Seq: 20, Col: 'Repay', Name: '還款', Witdh: 7, Height: 1, IsNeedHide: false, CanControlHide: true },
  { Seq: 21, Col: 'Received', Name: '小計', Witdh: 7, Height: 1, IsNeedHide: false, CanControlHide: true },
  { Seq: 22, Col: 'FeeTotal', Name: '掛帳費', Witdh: 7, Height: 1, IsNeedHide: false, CanControlHide: true },
  { Seq: 23, Col: 'Remark', Name: '說明', Witdh: 10, Height: 2, IsNeedHide: true, CanControlHide: true },
  { Seq: 24, Col: 'VisitSourceCode', Name: '初/複', Witdh: 5, Height: 1, IsNeedHide: false, CanControlHide: true },
];

// Class 版本
export class DailyReportColClass implements DailyReportCol {
  Seq: number;
  Col: string;
  Name: string;
  Witdh: number;
  Height: number;
  IsNeedHide: boolean;
  CanControlHide: boolean;

  constructor(col: DailyReportCol) {
    Object.assign(this, col);
  }

  // 額外功能：顯示用名稱
  get displayName(): string {
    return `[${this.Seq}] ${this.Name}`;
  }
}

// 🔹 只取出 "可以控制隱藏" 的欄位
export const DailyReportHideColEnum: DailyReportColClass[] =
  DailyReportColEnum
    .filter(c => c.CanControlHide)
    .map(c => new DailyReportColClass(c));
